import React from "react";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import {
    getPaymentCostCenter,
    ToogleActivationCostCenter
} from "../../../../api/financial";

import SaveCostcenter from './createEditModal'
import { Table } from "react-bootstrap";
import { formatCurrencyValue } from "../../../../utils";

export default (props) => {
    const [costCenters, setCostCenters] = React.useState([])
    const [showModal, setShowModal] = React.useState(false)
    const [editData, setEditData] = React.useState(false)
    const [filterActive, setFilterActive] = React.useState(true)

    function _getCenters() {
        getPaymentCostCenter({ is_active: filterActive, end_count:200 })
            .then(setCostCenters)
    }

    React.useEffect(() => {
        _getCenters()
    }, [filterActive])

    React.useEffect(() => {
        _getCenters()
    }, [])

    return (
        <div className="container col-12">
            <h2 className="text-center">
                Centros de Custo
                <span
                    className={`badge badge-${filterActive ? "secondary" : "danger"}`}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        setFilterActive(!filterActive)
                    }}
                >
                    {filterActive ? "Ativos" : "Desativados"}
                </span>
            </h2>
            <div className="text-center">
                <button
                    className="btn btn-sm btn-primary"
                    onClick={() => setShowModal(true)}
                >
                    Criar
                </button>
            </div>
            <Table striped bordered hover>
                <thead className="">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nome</th>
                        <th scope="col">Status</th>
                        <th scope="col">Pago</th>
                        <th scope="col">Recebido</th>
                        <th scope="col">Balanço</th>
                        <th scope="col">Ações</th>

                    </tr>
                </thead>
                <tbody>
                    {costCenters.map((center, _) => <tr>
                        <td>{_ + 1}</td>
                        <td>{center.name}</td>
                        <td>{center.is_active? "Ativo":"Desativado"}</td>
                        <td>{formatCurrencyValue(center.paid || 0)}</td>
                        <td>{formatCurrencyValue(center.received || 0)}</td>
                        <td>{formatCurrencyValue(center.received - center.paid || 0)}</td>
                        <td>
                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    setEditData(center);
                                    setShowModal(true)
                                }}>
                                Editar
                            </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    ToogleActivationCostCenter(center.id)
                                        .then(() => {
                                            _getCenters()
                                            setShowModal(false)
                                        })
                                }}>
                                {center.is_active ? "Desativar" : "Reativar"}
                            </button>
                        </td>
                    </tr>)}
                    <tr>

                    </tr>
                </tbody>
            </Table>

            <SaveCostcenter
                show={showModal}
                edit={editData}
                onHide={() => {
                    _getCenters()
                    setEditData(false)
                    setShowModal(false)
                }}
            />
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentCostCenter/list.jsx